import { ChangeEvent, useState } from 'react'
import { useParams } from 'react-router-dom'
import { useFormContext } from 'react-hook-form'
import { useMutation } from '@tanstack/react-query'

import { userUpdateData } from '../../../../../../app/services/usersService/userUpdate'
import { usersService } from '../../../../../../app/services/usersService'
import { useToast } from '../../../../../components/ui/use-toast'
import { FormSellerData } from '../../useSellerDetailsPageController'
import { deformateDate } from '../../../../../../app/utils/deformateDate'
import { cepService } from '../../../../../../app/services/cepService'
import { useBanks } from '../../../../../../app/hooks/useBanks'

export const useSellerPerfilController = () => {
  const { id } = useParams()
  const [value, setValue] = useState('')
  const methods = useFormContext<FormSellerData>()

  const { toast } = useToast()

  const { data } = useBanks({ allBanks: true })

  const optionBanks = data?.banks ?? []

  const { mutateAsync, isPending } = useMutation({
    mutationFn: async ({ data, id }: { data: userUpdateData; id: string }) => {
      return usersService.userUpdate(data, id)
    },
  })

  const handleAccountNumberBlur = (event: ChangeEvent<HTMLInputElement>) => {
    let newValue = event.target.value

    newValue = newValue.replace(/\D/g, '')

    if (newValue.length > 1 && !isNaN(Number(newValue))) {
      newValue = newValue.slice(0, -1) + '-' + newValue.slice(-1)
    }

    setValue(newValue)
  }

  const handleCepRequest = async (cep: string) => {
  const response = await cepService(cep.replace(/\D/g, ''))

    if (response) {
      methods.setValue('address.city', response.localidade)
      methods.setValue('address.complement', response.complemento)
      methods.setValue('address.neighborhood', response.bairro)
      methods.setValue('address.state', response.uf)
      methods.setValue('address.street', response.logradouro)
    }
  }

  const handleSellerInfoSubmit = async (data: FormSellerData) => {
    try {
      const formattedData = { ...data }

      if (data.birthDate) {
        formattedData.birthDate = deformateDate(data.birthDate)
      }
      formattedData.phone = data.phone?.replace(/\D/g, '')
      formattedData.address.zipCode = data.address.zipCode?.replace(/\D/g, '')
      formattedData.bankAccount.account = data.bankAccount.account?.replace(
        /\D/g,
        '',
      )

      if (id) {
        const response = await mutateAsync({ data: formattedData, id })

        if (response.name === data.name) {
          toast({
            title: 'Dados atualizados com sucesso!',
          })
        }
      }
    } catch (error) {
      console.log(error)
      toast({
        variant: 'destructive',
        title:
          'Ocorreu um erro ao tentar atualizar os dados, tente novamente mais tarde.',
      })
    }
  }

  return {
    isPending,
    handleSellerInfoSubmit,
    methods,
    handleAccountNumberBlur,
    value,
    setValue,
    handleCepRequest,
    optionBanks,
  }
}
